import { procoreClient } from "./client";

type Location = {
    id: string;
    name: string;
    node_name: string;
};

// Procore REST v2.0 collection endpoints are paginated (default 10 items per
// page, max 100), so a single request silently drops locations once a model
// has more than one page of levels (BM-12255).
const LOCATIONS_PER_PAGE = 100;

export async function getLocations(params: {
    companyId: number;
    projectId: number;
    locationIds: string[];
}): Promise<Location[]> {
    if (params.locationIds.length === 0) {
        return [];
    }

    const locations: Location[] = [];

    // The id filter caps the result set at the requested ids, so more pages
    // than this can only mean bad server data — bail out instead of looping.
    const maxPages = Math.ceil(params.locationIds.length / LOCATIONS_PER_PAGE);

    for (let page = 1; page <= maxPages; page++) {
        const searchParams = new URLSearchParams({
            "filters[id]": `[${params.locationIds.join(",")}]`,
            page: String(page),
            per_page: String(LOCATIONS_PER_PAGE),
        });

        const response = await procoreClient<{ data: Location[] }>(
            `/rest/v2.0/companies/${params.companyId}/projects/${params.projectId}/locations?${searchParams}`,
            {
                method: "GET",
            },
        );

        locations.push(...response.data);

        if (response.data.length < LOCATIONS_PER_PAGE || locations.length >= params.locationIds.length) {
            break;
        }
    }

    return locations;
}
